import {Authentication} from './authentication'
import {CognitoAuthentication} from './cognitoAuthentication'

let authenticationInstance: Authentication
export function getAuthenticationInstance(): Authentication {
    if (!authenticationInstance) {
        authenticationInstance = new CognitoAuthentication()
    }

    return authenticationInstance
}
